var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"width":"1500px","border-radius":"5px","margin":"0 auto","min-height":"100vh"}},[_c('enroll',{attrs:{"Info":_vm.Info},on:{"cancel-edit":_vm.monitor}}),_c('div',{staticStyle:{"width":"1500px","border-radius":"5px 5px 5px 5px","height":"auto"}},[_c('registrationList',{attrs:{"Info":_vm.Info}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }